import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIterateStep = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 38,
	height: 32,
	viewBox: "0 0 38 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M37.0308 17.5471L33.2388 12.8938V1.67164C33.2388 1.30062 32.9379 1 32.5671 1H13.4253C13.0545 1 12.7537 1.30062 12.7537 1.67164V7.82983L1.64713 15.446C1.46479 15.5713 1.35547 15.7785 1.35547 16C1.35547 16.2215 1.46479 16.4287 1.64713 16.554L12.7537 24.1702V30.3284C12.7537 30.6994 13.0545 31 13.4253 31H32.5671C32.9379 31 33.2388 30.6994 33.2388 30.3284V15.0205L35.9892 18.3958C36.1221 18.5587 36.3154 18.6431 36.5104 18.6431C36.6595 18.6431 36.8095 18.5936 36.9341 18.492C37.2218 18.2578 37.2651 17.8348 37.0308 17.5471ZM13.4253 8.99827L23.636 16L13.4253 23.0017L3.21473 16L13.4253 8.99827ZM14.097 29.6567V24.1702L25.2036 16.554C25.3859 16.4287 25.4952 16.2215 25.4952 16C25.4952 15.7785 25.3859 15.5713 25.2036 15.446L14.097 7.82983V2.34328H31.8955V12.8938L28.1035 17.5471C27.8691 17.8348 27.9124 18.2578 28.2001 18.492C28.4874 18.7266 28.9107 18.6833 29.1451 18.3958L31.8955 15.0205V29.6567H14.097Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: .7
	})
});
export default SvgIterateStep;
